import { ShieldX } from "lucide-react";
import { Container, IconContainer, Mensagem } from "./styles";

interface AbaAcessoNegadoProps {
    mensagem?: string;
}

export default function AbaAcessoNegado({ mensagem = "Acesso não autorizado." }: AbaAcessoNegadoProps) {
    return (
        <Container>
            <IconContainer>
                <ShieldX size={48} />
            </IconContainer>
            <Mensagem>{mensagem}</Mensagem>
        </Container>
    );
}


